import React from 'react'
import { Tabs } from 'antd'
import { crmTabs } from './tabs'
import classNames from 'classnames'
import styles from './CrmTabs.module.scss'
import { useLocation } from 'react-router-dom'
import useCurrentTab from '@hooks/useCurrentTab'

interface Props {
  crmId: string
  crmName: string
}

const CrmTabs: React.FC<Props> = ({ crmId, crmName }) => {
  const { pathname } = useLocation()
  const activeTab = useCurrentTab(pathname, crmTabs({ crmId, crmName }))
  const items = crmTabs({ crmId, crmName }).map((el, index) => ({
    label: <>{el.title}</>,
    key: String(index),
  }))
  return (
    <Tabs
      defaultActiveKey='0'
      activeKey={String(activeTab)}
      items={items}
      className={classNames(styles.TabsUi, styles['style'])}
    />
  )
}

export default CrmTabs
